<template>
  <AddBanner />
</template>

<script>
// @ is an alias to /src
import AddBanner from "@/components/AddBanner.vue";

export default {
  name: "AddBanners",
  components: {
    AddBanner,
  },
};
</script>
